"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Modal = void 0;
var React = _interopRequireWildcard(require("react"));
var _utils = require("../utils");
require("../../../src/ui/modal/modal.module.scss");
var _button = require("../button/button");
var _icon = require("../icon/icon");
var _buttonsGroup = require("../buttonsGroup/buttonsGroup");
var _reactMultiCarousel = _interopRequireDefault(require("react-multi-carousel"));
require("../../../src/ui/modal/carousel.scss");
var _modalSlide = require("./modalSlide");
var _uuid = require("uuid");
var _reactFocusLock = _interopRequireDefault(require("react-focus-lock"));
var _excluded = ["children", "className", "blockSelector", "buttons", "isNotFocusLock", "release", "title", "variant", "onClose"],
  _excluded2 = ["isOpenedAfterClick", "isPrimary", "text", "onClick"],
  _excluded3 = ["carouselState", "children"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n["default"] = e, t && t.set(e, n), n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) { n[e] = r[e]; } return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }
// accessibility ok

var Modal = function Modal(props) {
  var children = props.children,
    className = props.className,
    blockSelector = props.blockSelector,
    buttons = props.buttons,
    isNotFocusLock = props.isNotFocusLock,
    release = props.release,
    title = props.title,
    variant = props.variant,
    onClose = props.onClose,
    attributes = _objectWithoutProperties(props, _excluded),
    slides = null,
    footer = null;
  var _React$useState = React.useState('kui-modal--' + (0, _uuid.v4)()),
    _React$useState2 = _slicedToArray(_React$useState, 1),
    uniqueClass = _React$useState2[0];
  var _React$useState3 = React.useState(variant === 'release' && release && release.slides && release.slides[0] && release.slides[0].title ? release.slides[0].title : title),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    titleHook = _React$useState4[0],
    setTitleHook = _React$useState4[1];
  className = (0, _utils.ClassNames)('kui-modal', uniqueClass, variant ? 'kui-modal--variant_' + variant : null, className);
  var buttonsGroup = [];
  if (buttons) {
    buttonsGroup = buttons.map(function (item, key) {
      var isOpenedAfterClick = item.isOpenedAfterClick,
        isPrimary = item.isPrimary,
        text = item.text,
        onClick = item.onClick,
        attributes = _objectWithoutProperties(item, _excluded2);
      var onClickButton = function onClickButton() {
        if (onClick) onClick();
        if (!isOpenedAfterClick) onClose();
      };
      return /*#__PURE__*/React.createElement(_button.Button, _extends({
        className: "kui-modal__footer-button",
        key: key,
        size: "large",
        variant: isPrimary ? 'primary' : 'secondary',
        onClick: onClickButton
      }, attributes), text);
    });
    footer = /*#__PURE__*/React.createElement("div", {
      className: "kui-modal__footer kui-modal__footer--buttons"
    }, /*#__PURE__*/React.createElement(_buttonsGroup.ButtonsGroup, {
      className: "kui-modal__footer-buttons",
      size: "large"
    }, buttonsGroup));
  }
  if (variant === 'release' && release) {
    footer = release.footer && /*#__PURE__*/React.createElement("div", {
      className: "kui-modal__footer kui-modal__footer--release"
    }, /*#__PURE__*/React.createElement("div", {
      className: "kui-modal__footer-stars"
    }, /*#__PURE__*/React.createElement(_icon.Icon, {
      size: 24,
      xlink: "google-color"
    }), /*#__PURE__*/React.createElement("div", {
      className: "kui-modal__footer-stars-text",
      dangerouslySetInnerHTML: {
        __html: release.footer.stars
      }
    })), /*#__PURE__*/React.createElement("div", {
      className: "kui-modal__footer-follow"
    }, /*#__PURE__*/React.createElement("div", {
      className: "kui-modal__footer-follow-text"
    }, release.footer.follow.text), /*#__PURE__*/React.createElement(_buttonsGroup.ButtonsGroup, {
      className: "kui-modal__footer-follow-buttons",
      size: "large"
    }, release.footer.follow.socials.map(function (social) {
      return /*#__PURE__*/React.createElement(_button.Button, {
        href: social.link,
        key: social.name,
        target: "_blank",
        tooltip: social.name,
        variant: "icon-text"
      }, /*#__PURE__*/React.createElement(_icon.Icon, {
        className: "kui-modal__footer-follow-icon",
        size: 24,
        xlink: social.icon
      }));
    }))));
    var ArrowFix = function ArrowFix(arrowProps) {
      var carouselState = arrowProps.carouselState,
        children = arrowProps.children,
        restArrowProps = _objectWithoutProperties(arrowProps, _excluded3);
      return /*#__PURE__*/React.createElement(_button.Button, _extends({
        variant: "icon"
      }, restArrowProps), children);
    };
    var arrowLeft = /*#__PURE__*/React.createElement(ArrowFix, {
      className: "kui-modal__slides-arrow kui-modal__slides-arrow--left"
    }, /*#__PURE__*/React.createElement(_icon.Icon, {
      size: 24,
      xlink: "arrow-left"
    }));
    var arrowRight = /*#__PURE__*/React.createElement(ArrowFix, {
      className: "kui-modal__slides-arrow kui-modal__slides-arrow--right"
    }, /*#__PURE__*/React.createElement(_icon.Icon, {
      size: 24,
      xlink: "arrow-right"
    }));
    var afterChange = function afterChange(previousSlide, state) {
      var slidesCount = release.slides.length;
      var newIndex = state.currentSlide - 2;
      if (newIndex < 0) {
        newIndex += slidesCount;
      } else if (newIndex >= slidesCount) {
        newIndex -= slidesCount;
      }
      setTitleHook(release.slides[newIndex].title);
    };
    if (release.slides.length > 1) {
      var CustomDot = function CustomDot(_ref) {
        var active = _ref.active,
          onClick = _ref.onClick;
        var className = 'kui-modal__slides-dot';
        return /*#__PURE__*/React.createElement(_button.Button, {
          className: "\n                            ".concat(className, "\n                            ").concat(active ? className + '--active' : '', "\n                        "),
          variant: 'icon',
          onClick: onClick
        });
      };
      slides = /*#__PURE__*/React.createElement(_reactMultiCarousel["default"], {
        additionalTransfrom: 0,
        afterChange: afterChange,
        arrows: true,
        centerMode: false,
        containerClass: "kui-modal__slides",
        customDot: /*#__PURE__*/React.createElement(CustomDot, null),
        customLeftArrow: arrowLeft,
        customRightArrow: arrowRight,
        dotListClass: "kui-modal__slides-dots",
        draggable: true,
        focusOnSelect: false,
        infinite: true,
        itemClass: "kui-modal__slide",
        keyBoardControl: true,
        minimumTouchDrag: 80,
        renderDotsOutside: false,
        responsive: {
          desktop: {
            breakpoint: {
              max: 3000,
              min: 1024
            },
            items: 1
          },
          mobile: {
            breakpoint: {
              max: 464,
              min: 0
            },
            items: 1
          },
          tablet: {
            breakpoint: {
              max: 1024,
              min: 464
            },
            items: 1
          }
        },
        showDots: true,
        sliderClass: "",
        slidesToSlide: 1,
        swipeable: true
      }, release.slides.map(function (slide, index) {
        return /*#__PURE__*/React.createElement(_modalSlide.ModalSlide, _extends({}, slide, {
          key: index + slide.title
        }));
      }));
    } else if (release.slides.length) {
      slides = /*#__PURE__*/React.createElement(_modalSlide.ModalSlide, release.slides[0]);
    }
  }
  var closeButton = /*#__PURE__*/React.createElement(_button.Button, {
    className: "kui-modal__close",
    variant: "icon",
    "aria-label": 'Close',
    onClick: onClose
  }, /*#__PURE__*/React.createElement(_icon.Icon, {
    size: 24,
    xlink: "close"
  }));
  var onKeyDown = function onKeyDown(e) {
    if (!e) return;
    if (e.key === 'Escape') {
      e.stopPropagation();
      return onClose();
    }
  };
  React.useEffect(function () {
    var block = document.querySelector(blockSelector);
    if (block) block.setAttribute('aria-hidden', 'true'); // скрыть контент под модалкой от скринридера

    return function () {
      if (block) block.setAttribute('aria-hidden', 'false');
    };
  }, []);
  var item = /*#__PURE__*/React.createElement("form", {
    className: "kui-modal__item",
    role: 'dialog',
    "aria-modal": true,
    "aria-labelledby": uniqueClass + '__header-title',
    "aria-describedby": uniqueClass + '__body'
  }, /*#__PURE__*/React.createElement("div", {
    className: "kui-modal__header"
  }, /*#__PURE__*/React.createElement("div", {
    className: "kui-modal__header-title",
    id: uniqueClass + '__header-title',
    dangerouslySetInnerHTML: {
      __html: titleHook
    }
  }), closeButton), /*#__PURE__*/React.createElement("div", {
    className: "kui-modal__body",
    id: uniqueClass + '__body'
  }, children, slides), footer);
  return /*#__PURE__*/React.createElement("div", _extends({
    className: className,
    "aria-hidden": 'false',
    onKeyDown: onKeyDown
  }, attributes), /*#__PURE__*/React.createElement("div", {
    className: "kui-modal__overlay",
    onClick: onClose
  }), isNotFocusLock ? item : /*#__PURE__*/React.createElement(_reactFocusLock["default"], {
    returnFocus: true
  }, item));
};
exports.Modal = Modal;
Modal.defaultProps = {
  blockSelector: '.content',
  // основной контент в Kanbanchi
  buttons: null,
  release: null,
  title: '',
  variant: null,
  onClose: function onClose() {
    return null;
  }
};
Modal.displayName = 'Modal';